export const MediaChannel = {
    "Audio": {
        "id": 8,
        "label": "Audio"
    },
    "Display": {
        "id": 1,
        "label": "Display"
    },
    "Video": {
        "id": 2,
        "label": "Video"
    }
}